
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		providerSelectItem
	} from '@/api/supplier';
	import UploadImg from '@/components/upload-img.vue';
	import Dialog from '@/components/dialog.vue';
  import {
    financecontractInvoiceStatistics,
    financebuyAndSellContractReceiveInvoice,
    financecontractInvoice
  } from "@/api/finance"
	import Message from '@/components/message.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate,
      UploadImg,
			'slz-dialog': Dialog,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private loading = false
    private result:any = {}
    private radioType = 1
    private radioList = [
      {value:1,label:'待对方开票'},
      {value:2,label:'已开票'},
    ]
    private supplierNameKey = ''
    private orderNo = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private chooselist:any = []
    private allMoney = 0
    private rowmsg:any = {}
    private keywords = ''

    private uploadShow = false
		private filelist:any = []
    private uploading = false
    private showMessage = false

    private mounted () {
      this.getmoney()
      this.gettablelist()
    }
    
    private activated () {
      this.getmoney()
      this.gettablelist()
    }

    private toDetail(row){
      this.$router.push({
        path:'purchasesaleContractDetail',
        query:{
          Id:row.ProviderId,
          Name:encodeURIComponent(row.ProviderName),
          SettleMoney:row.SettleMoney,
          Ids:row.Ids,
          InvoiceState:String(this.radioType)
        }
      })
    }
    private exportFile(){
      let url = location.origin + '/pc/finance/contractInvoiceExport'
      url += '?ContractType=2'
      url += '&InvoiceState=' + this.radioType
      url += '&ProviderName=' + this.supplierNameKey
      url += '&BillNo=' + this.orderNo
      window.open(url)
    }
    private async confirmupload(){
      if(!this.filelist||!this.filelist.length){
        this.$message.error('请先选择要上传的文件')
        return
      }
      try{
        this.uploading = true
        let res:any = await ({})
        if(res.IsSuccess){
          this.$message.success('操作成功')
        }
      }finally{
        this.uploading = false
      }
    }
    private uploadSuc(file,num){
      this.filelist = file
    }
    private toinvoice(){
      if(!this.chooselist||!this.chooselist.length){
        this.$message.error('请选择已收到发票的账单')
        return 
      }
      this.showMessage = true
    }
    private async confirminvoice(){
      try{
        let list = this.chooselist.reduce((val,item)=>{
          return val.concat(item.IdList.map(v=>Number(v)))
        },[])
        let res = await financebuyAndSellContractReceiveInvoice({
          IdList:list
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private selectionchange(list){
      // console.log(list)
      this.chooselist = list
      this.allMoney = this.chooselist.reduce((all,v)=>{
        return all+=v.SettleMoney
      },0)
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private clearSearch(){
      this.supplierNameKey = null
      this.orderNo = ''
      this.pageNo = 1
      this.keywords = ''
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await financecontractInvoice({
          ContractType:2,
          InvoiceState:this.radioType,
          ProviderName:this.supplierNameKey,
          BillNo:this.orderNo,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
          let table = (this as any).$refs.table
          if(table){
            table.clearSelection()
          }
        }
      }finally{
        this.tableloading = false
      }
    }
    private async getmoney(){
      try{
        this.loading = true
        let res = await financecontractInvoiceStatistics({
          ContractType:2
        })
        if(res.IsSuccess){
          this.result = res.Result
        }
      }finally{
        this.loading = false
      }
    }
    private changeType(e){
      this.pageNo = 1
      this.gettablelist()
    }
  }
